import ReactDOM from 'react-dom';
import App from './components/App';
import { persistor, store } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import './constants/polyfills'; //custom polyfills
import 'core-js/stable'; // Polyfill ES features
import 'regenerator-runtime/runtime'; // Polyfill async/await

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,

  document.getElementById('root')
);
